import parsePhoneNumberFromString from 'libphonenumber-js'

import { DOCUMENT_TYPE } from '@/constants/documentType'

import { formatToCpf } from './cpf'

export const formatDocumentNumber = (documentNumber, documentType, country = null) => {
  if (documentType === DOCUMENT_TYPE.TELEPHONE) {
    const phoneNumber = parsePhoneNumberFromString(`+${documentNumber}`, {
      defaultCountry: country
    })
    if (phoneNumber?.isValid && phoneNumber?.isPossible) return phoneNumber.formatInternational()
  }
  return formatToCpf(documentNumber)
}

export const labelByDocumentType = (documentType) => {
  switch (documentType) {
    case DOCUMENT_TYPE.TELEPHONE:
      return 'Telefone'
    case DOCUMENT_TYPE.CNPJ:
      return 'CNPJ'
    default:
      return 'CPF'
  }
}
